module.exports = {["template-constructor-control-hotspot_add"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="icon noarrow"\n	     data-alt="Add Pin"\n	     data-alt-pos="left"\n	     data-alt-offset="9"></div>\n\n';
}
return __p;
},}